module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/section01_02_american-village-fe353175e0f39b1ef00308e309bbcaba.jpg";